import * as React from "react";
import { CardTimeline } from "./components";

export interface Props {
  data: any[];
  mode: "desktop" | "mobile";
}

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/timeline/`;

const SocTimeline: React.FC<Props> = ({ data = [], mode }) => {
  if (mode === "mobile") {
    return (
      <div className="flex flex-col gap-x-[20px] items-center w-[100%]">
        {data?.map((item, idx) => {
          const isFirstItem = idx === 0;
          const isLastDay = idx === data?.length - 1;

          return (
            <div
              key={idx}
              style={{ marginTop: isFirstItem ? 20 : 0 }}
              className="flex gap-x-[16px] h-[max-content] w-[100%]  overflow-y-hidden"
            >
              <div className="flex flex-col items-center">
                <div className="h-[16px] w-[16px] rounded-full bg-white" />
                {!isLastDay && <div className="w-[1px] h-full bg-white relative" />}
              </div>
              <div className="flex flex-col gap-4 w-[100%]">
                <div className="flex justify-between items-center">
                  <h1 className="leading-0 text-[16px] text-[#BFEEFC] title-text">{item?.day}</h1>
                  <p className="leading-0 text-[14px] text-white">{item?.date}</p>
                </div>
                {item?.timeline?.map((val, idx) => (
                  <CardTimeline
                    key={idx}
                    icon={
                      <img
                        src={`${imgPath}${val?.icon}`}
                        width={30}
                        height={30}
                        alt="icon card timeline"
                      />
                    }
                    title={val?.title}
                    subtitle={val?.subtitle}
                  />
                ))}
                <div className="h-[16px]" />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex mt-[80px] w-[100%]">
      {data?.map((item, idx) => {
        const isLastDay = idx === data?.length - 1;

        return (
          <div key={idx} className="flex flex-col">
            <div className="flex items-center mb-[8px]">
              <div className="h-[16px] w-[16px] rounded-full bg-white" />
              {!isLastDay && <div className="w-full h-[1px] bg-white relative" />}
            </div>
            <div className="flex flex-col gap-4 w-[100%]">
              <div className="flex flex-col">
                <h1 className="leading-0 text-[16px] text-[#BFEEFC] title-text">{item?.day}</h1>
                <p className="leading-0 text-[14px] text-white">{item?.date}</p>
              </div>
              <div className="flex">
                <div className="flex gap-y-[16px] flex-col">
                  {item?.timeline?.map((val, idx) => (
                    <CardTimeline
                      key={idx}
                      icon={
                        <img
                          src={`${imgPath}${val?.icon}`}
                          width={30}
                          height={30}
                          alt="icon card timeline"
                        />
                      }
                      title={val?.title}
                      subtitle={val?.subtitle}
                    />
                  ))}
                </div>
                <div className="w-[28px]" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SocTimeline;
